import { createAction, props } from '@ngrx/store';
import { Contract } from 'src/app/compliance/models/contract';
import {
    AssignedDocument, PendingDocuments
} from 'src/app/compliance/models/posted-documents-models';
import { ComplianceCandidateDocumentNoteDto } from '../../api/models/compliance-candidate-document-note-dto.model';

export const loadPendingDocuments = createAction('[DOCUMENT BATCH DETAILS] Load Pending Documents');
export const loadPendingDocumentsSuccess = createAction(
    '[DOCUMENT BATCH DETAILS] Load Pending Documents Success',
    props<{ pendingDocs: PendingDocuments[] }>()
);
export const loadPendingDocumentsFailure = createAction(
    '[DOCUMENT BATCH DETAILS] Load Pending Documents Failure',
    props<{ error: unknown }>()
);

export const loadAssignedDocuments = createAction('[DOCUMENT BATCH DETAILS] Load Assigned Documents');
export const loadAssignedDocumentsSuccess = createAction(
    '[DOCUMENT BATCH DETAILS] Load Assigned Documents Success',
    props<{ assignedDocs: AssignedDocument[] }>()
);
export const loadAssignedDocumentsFailure = createAction(
    '[DOCUMENT BATCH DETAILS] Load Assigned Documents Failure',
    props<{ error: unknown }>()
);

export const loadDocumentNotes = createAction('[DOCUMENT BATCH DETAILS] Load Document Notes');
export const loadDocumentNotesSuccess = createAction(
    '[DOCUMENT BATCH DETAILS] Load Document Notes Success',
    props<{ notes: ComplianceCandidateDocumentNoteDto[] }>()
);
export const loadDocumentNotesFailure = createAction(
    '[DOCUMENT BATCH DETAILS] Load Document Notes Failure',
    props<{ error: unknown }>()
);

export const loadDocumentContractHistory = createAction('[DOCUMENT BATCH DETAILS] Load Document Contract History');
export const loadDocumentContractHistorySuccess = createAction(
    '[DOCUMENT BATCH DETAILS] Load Document Contract History Success',
    props<{ contracts: Contract[] }>()
);
export const loadDocumentContractHistoryFailure = createAction(
    '[DOCUMENT BATCH DETAILS] Load Document Contract History Failure',
    props<{ error: unknown }>()
);

export const setCandidateId = createAction(
    '[DOCUMENT BATCH DETAILS] Set Candidate Id',
    props<{ candidateId: number }>()
);
export const setAssignedUploaderId = createAction(
    '[DOCUMENT BATCH DETAILS] Set Assigned Uploader Id',
    props<{ assignedUploaderId: number }>()
);
export const setIsSignedContract = createAction(
    '[DOCUMENT BATCH DETAILS] Set Is Signed Contract',
    props<{ isSignedContract: boolean }>()
);
export const setIsCandidateUpload = createAction(
    '[DOCUMENT BATCH DETAILS] Set Is Candidate Upload',
    props<{ isCandidateUpload: boolean }>()
);

export const goToDocumentReviewer = createAction(
    '[DOCUMENT BATCH DETAILS] Go To Document Reviewer',
    props<{ url: string }>()
);
export const goToDocumentReviewerFromAssignedPages = createAction(
    '[DOCUMENT BATCH DETAILS Assigned Pages] Go To Document Reviewer From Assigned Pages',
    props<{ url: string; documentId: number }>()
);

export const postDocumentNote = createAction(
    '[DOCUMENT BATCH DETAILS] Post Document Note To Multiple Documents',
    props<{ candidateDocumentIds: number[]; note: string }>()
);

export const addDocumentNoteSuccess = createAction(
    '[DOCUMENT BATCH DETAILS] Posted Document Note To Document Success',
    props<{ result: unknown }>()
);
export const addDocumentNoteFailure = createAction(
    '[DOCUMENT BATCH DETAILS] Posted Document Note To Document Failure',
    props<{ error: unknown }>()
);

export const openDocumentPage = createAction(
    '[DOCUMENT BATCH DETAILS API] Open Document Page',
    props<{ pageNum: number; docId: number }>()
);

export const setExpireDate = createAction(
    '[DOCUMENT BATCH DETAILS] Set Expire Date',
    props<{ documentId: number; requirementId: number; expires: Date }>()
);
